import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bid-questions-container"
}
const _hoisted_2 = { class: "questions-header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "header-icon" }
const _hoisted_5 = { class: "header-stats" }
const _hoisted_6 = { class: "stat-item" }
const _hoisted_7 = { class: "stat-item" }
const _hoisted_8 = { class: "stat-value" }
const _hoisted_9 = { class: "stat-label" }
const _hoisted_10 = { class: "progress-section" }
const _hoisted_11 = { class: "progress-info" }
const _hoisted_12 = { class: "progress-bar-container" }
const _hoisted_13 = { class: "progress-status" }
const _hoisted_14 = { class: "question-header" }
const _hoisted_15 = { class: "question-badge" }
const _hoisted_16 = { class: "question-content" }
const _hoisted_17 = { class: "question-text" }
const _hoisted_18 = { class: "question-meta" }
const _hoisted_19 = { class: "meta-tag word-limit" }
const _hoisted_20 = {
  key: 0,
  class: "meta-tag required"
}
const _hoisted_21 = {
  key: 1,
  class: "meta-tag optional"
}
const _hoisted_22 = { class: "question-body" }
const _hoisted_23 = { class: "textarea-wrapper" }
const _hoisted_24 = {
  key: 0,
  class: "status-message warning"
}
const _hoisted_25 = {
  key: 1,
  class: "status-message error"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import { RAW_ASSETS_STATUSES } from '@/constants/statuses';
import { validators } from '../../utils/validators';

interface IProps {
  isDisabledForm: boolean;
}
// eslint-disable-next-line

export default /*@__PURE__*/_defineComponent({
  __name: 'BidViewQuestions',
  props: {
    isDisabledForm: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const { getters, commit } = useStore();

// Computed
const auctionStatus = computed<string>(() => {
  const { status } = getters['getAsset'] ?? {};
  return status;
});

const isPreBid = computed<boolean>(() => {
  return [RAW_ASSETS_STATUSES.ACTIVE, RAW_ASSETS_STATUSES.PRE_AUCTION].includes(
    auctionStatus.value
  );
});

// Computed
const questions = computed(() => {
  const qs = getters['getAssetQuestions'] || [];
  console.log('BidViewQuestions: questions', JSON.parse(JSON.stringify(qs)));
  return qs;
});
const responses = computed(() => {
  const rs = getters['getResponsesValues'] || {};
  console.log(
    'BidViewQuestions: responses from getter',
    JSON.parse(JSON.stringify(rs))
  );
  return rs;
});

const totalQuestions = computed(() => questions.value.length);
const answeredCount = computed(() => {
  return Object.values(responses.value).filter(
    (response) =>
      response && typeof response === 'string' && response.trim().length > 0
  ).length;
});
const completionPercentage = computed(() => {
  if (totalQuestions.value === 0) return 0;
  return Math.round((answeredCount.value / totalQuestions.value) * 100);
});

// Rules
const rules = {
  required: (v: string) => validators.required(v)
};

// Methods
const getWordCount = (text: string | undefined): number => {
  if (!text || typeof text !== 'string') return 0;
  const trimmed = text.trim();
  if (trimmed.length === 0) return 0;
  return trimmed.split(/\s+/).length;
};

const updateResponse = (index: number, value: string) => {
  const currentResponses = { ...responses.value };
  if (value && value.trim()) {
    currentResponses[index] = value;
  } else {
    delete currentResponses[index];
  }
  commit('setResponsesValues', currentResponses);
};

const getStatusClass = (index: number, question: any): string => {
  const response = responses.value[index];
  const wordCount = getWordCount(response);

  if (response && wordCount > question.word_limit) {
    return 'status--exceeded';
  }
  if (response && wordCount > 0) {
    return 'status--complete';
  }
  if (question.required) {
    return 'status--required';
  }
  return 'status--pending';
};

const getStatusIcon = (index: number, question: any): string => {
  const response = responses.value[index];
  const wordCount = getWordCount(response);

  if (response && wordCount > question.word_limit) {
    return 'mdi-alert-circle';
  }
  if (response && wordCount > 0) {
    return 'mdi-check-circle';
  }
  if (question.required) {
    return 'mdi-alert';
  }
  return 'mdi-circle-outline';
};

const getStatusText = (index: number, question: any): string => {
  const response = responses.value[index];
  const wordCount = getWordCount(response);

  if (response && wordCount > question.word_limit) {
    return 'Exceeded';
  }
  if (response && wordCount > 0) {
    return 'Complete';
  }
  if (question.required) {
    return 'Required';
  }
  return 'Optional';
};

const getWordCountClass = (index: number, question: any): string => {
  const response = responses.value[index];
  const wordCount = getWordCount(response);

  if (wordCount > question.word_limit) {
    return 'exceeded';
  }
  if (wordCount > 0 && wordCount <= question.word_limit) {
    return 'valid';
  }
  return '';
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (questions.value.length > 0 && isPreBid.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-help-circle-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-text" }, [
              _createElementVNode("h2", null, "Pre-Bid Questions"),
              _createElementVNode("p", { class: "subtitle" }, [
                _createTextVNode(" Please answer the following questions. Required questions are marked with "),
                _createElementVNode("span", { class: "required-marker" }, "*")
              ])
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["stat-value", { complete: answeredCount.value === totalQuestions.value }])
              }, _toDisplayString(answeredCount.value), 3),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "stat-label" }, "Answered", -1))
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(totalQuestions.value), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(totalQuestions.value === 1 ? 'Question' : 'Questions'), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "progress-label" }, "Completion Progress", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["progress-percentage", { complete: completionPercentage.value === 100 }])
            }, _toDisplayString(completionPercentage.value) + "% ", 3)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(["progress-bar", { complete: completionPercentage.value === 100 }]),
              style: _normalizeStyle({ width: `${completionPercentage.value}%` })
            }, null, 6)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_icon, {
              size: "14",
              color: completionPercentage.value === 100 ? 'success' : 'grey'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(completionPercentage.value === 100
              ? 'mdi-check-circle'
              : 'mdi-progress-check'), 1)
              ]),
              _: 1
            }, 8, ["color"]),
            _createElementVNode("span", null, _toDisplayString(answeredCount.value) + " of " + _toDisplayString(totalQuestions.value) + " questions completed", 1)
          ])
        ]),
        _createVNode(_TransitionGroup, {
          name: "question-list",
          tag: "div",
          class: "questions-list"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["question-card", {
          'question-card--required': question.required && !responses.value[index],
          'question-card--complete':
            responses.value[index] && getWordCount(responses.value[index]) > 0,
          'question-card--exceeded':
            responses.value[index] &&
            getWordCount(responses.value[index]) > question.word_limit
        }])
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", null, "Q" + _toDisplayString(index + 1), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h3", _hoisted_17, _toDisplayString(question.text), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-text-short", -1)
                          ]))]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(question.word_limit) + " words max ", 1)
                      ]),
                      (question.required)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode("mdi-asterisk", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[7] || (_cache[7] = _createTextVNode(" Required ", -1))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode("mdi-checkbox-blank-circle-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[9] || (_cache[9] = _createTextVNode(" Optional ", -1))
                          ]))
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["question-status", getStatusClass(index, question)])
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getStatusIcon(index, question)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("span", null, _toDisplayString(getStatusText(index, question)), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_v_textarea, {
                      "model-value": responses.value[index] || '',
                      disabled: __props.isDisabledForm,
                      variant: "outlined",
                      placeholder: "Enter your response...",
                      rows: "5",
                      "hide-details": "",
                      class: "custom-textarea",
                      "onUpdate:modelValue": ($event: any) => (updateResponse(index, $event))
                    }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["word-counter", getWordCountClass(index, question)])
                    }, [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("mdi-counter", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(getWordCount(responses.value[index])) + " / " + _toDisplayString(question.word_limit) + " words", 1)
                    ], 2)
                  ]),
                  _createVNode(_Transition, { name: "status-fade" }, {
                    default: _withCtx(() => [
                      (question.required && !responses.value[index])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createVNode(_component_v_icon, { size: "18" }, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode("mdi-alert-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[12] || (_cache[12] = _createElementVNode("span", null, "This question requires a response", -1))
                          ]))
                        : (
                responses.value[index] &&
                getWordCount(responses.value[index]) > question.word_limit
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createVNode(_component_v_icon, { size: "18" }, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                  _createTextVNode("mdi-alert-circle-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("span", null, " Response exceeds word limit by " + _toDisplayString(getWordCount(responses.value[index]) - question.word_limit) + " words ", 1)
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ], 2))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})